export default __webpack_public_path__ + "static/media/RAW_Logo.06ed3bed.png";